import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Handshake } from "lucide-react";

/** Sezione footer gemellaggi / relazioni estere — chiusa di default, tendina Apri/Chiudi. */
export default function FooterGemellaggi() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <div className="border-t border-borderline bg-parchment/50" data-testid="footer-gemellaggi">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls="footer-gemellaggi-panel"
        className="w-full max-w-[1400px] mx-auto px-5 md:px-10 py-4 flex items-center justify-between gap-4 text-left hover:bg-parchment2/40 transition-colors"
        data-testid="footer-gemellaggi-toggle"
      >
        <div className="min-w-0">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-terracotta mb-1 inline-flex items-center gap-2">
            <Handshake size={11} aria-hidden />
            Relazioni estere
          </p>
          <p className="font-display text-lg sm:text-xl text-ink leading-snug">
            <span className="text-terracotta">Gemellaggi</span> e comuni amici
            <span className="hidden sm:inline text-ink2 font-sans text-sm font-normal">
              {" "}
              — rete dei borghi e città sorelle
            </span>
          </p>
        </div>
        <span
          className={`shrink-0 flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-ink2 ${
            open ? "text-terracotta" : ""
          }`}
        >
          {open ? "Chiudi" : "Apri"}
          <ChevronDown
            size={18}
            className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`}
            aria-hidden
          />
        </span>
      </button>

      {open && (
        <div
          id="footer-gemellaggi-panel"
          className="border-t border-borderline/80"
          data-testid="footer-gemellaggi-panel"
        >
          <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 space-y-4">
            <p className="text-sm text-ink2 leading-relaxed max-w-2xl">
              Esplora i gemellaggi istituzionali tra comuni italiani e città estere, e la rete dei
              comuni amici del Network 6amico: mappe, storie e relazioni tra territori.
            </p>
            <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm list-none m-0 p-0">
              <li>
                <Link
                  to="/gemellaggi"
                  className="font-medium text-terracotta hover:underline"
                  data-testid="footer-gemellaggi-link"
                >
                  Rete gemellaggi →
                </Link>
              </li>
              <li>
                <Link
                  to="/comuni-amici"
                  className="text-ink2 hover:text-terracotta transition-colors"
                  data-testid="footer-comuni-amici-link"
                >
                  Comuni amici →
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
